import { useQuery, keepPreviousData, useMutation } from '@tanstack/react-query';
import { getInsuranceCarriers, getAvailableInsuranceCarriers, createInsuranceCarrier, getInsuranceCarriersFromSoftseguros, uploadInsuranceCarrierCertificate } from '@features/insuranceCarriers/services/insuranceCarriersService';

const BASE = 'insuranceCarriers';

export const insuranceCarriersQueryKeys = {
    base: () => [BASE],
    list: (filters) => filters ? [BASE, 'list', filters] : [BASE, 'list'],
    available: () => [BASE, 'available'],
    listFromSoftseguros: () => [BASE, 'listFromSoftseguros'],
}

export const useGetInsuranceCarriers = (filters, { enabled = true, ...queryOptions } = {}) => {
    return useQuery({
        queryKey: insuranceCarriersQueryKeys.list(filters),
        placeholderData: keepPreviousData,
        queryFn: () => getInsuranceCarriers(filters),
        enabled,
        ...queryOptions,
    });
};

export const useGetAvailableInsuranceCarriers = () => {
    return useQuery({
        queryKey: insuranceCarriersQueryKeys.available(),
        placeholderData: keepPreviousData,
        queryFn: () => getAvailableInsuranceCarriers(),
    });
};

export const useGetInsuranceCarriersFromSoftseguros = () => {
    return useQuery({
        queryKey: insuranceCarriersQueryKeys.listFromSoftseguros(),
        queryFn: () => getInsuranceCarriersFromSoftseguros(),
    })
}

export const useCreateInsuranceCarrier = () => {
    return useMutation({
        mutationFn: (data) => createInsuranceCarrier(data),
    });
};

export const useUploadInsuranceCarrierCertificate = () => {
    return useMutation({
        mutationFn: ({ id, file, password }) => uploadInsuranceCarrierCertificate(id, { file, password }),
    });
};